// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__Fo1CD"};